<template src='./plan.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import FormSetup from '@/components/misc/form-setup/FormSetup'

const CURRENCY_ID_1 = 'root.financial info.funding.sources'
const CURRENCY_ID_2 = 'root.financial info.price foreign'
const ORGANIZATION_ID = 'root.proposer info.proposer organization.proposer'
const activityYears = 'root.implementation'

export default {
  components: {
    'form-setup': FormSetup
  },
  data () {
    return {
      autoCompleteUrl_budgetId: Vue.$apiConfig.budgetUsersGet,
      autoCompleteUrl_currency: Vue.$apiConfig.exchangeRateGet,
      help: {
        form: Vue.$helpConfig.projectFormPlan
      },
      formMarkdownElements: [
        {
          editor: 'root.comment',
          element: 'root[comment]',
          name: 'comment'
        }
      ],
      activityCalculations: [],
      activitySumAmounts: [],
      fundingCalculations: [],
      fundingSumAmounts: []
    }
  },
  methods: {
    handleHiddenFields () {
      if (!this.$refs.setup.editor.editors['root.financial info.funding.sources']) return
      for (let i = 0; i <= this.$refs.setup.editor.editors['root.financial info.funding.sources'].rows.length - 1; i++) {
        if (!this.$refs.setup.editor.editors['root.financial info.funding.sources'].rows[i].value.name) {
          this.$refs.setup.editor.editors['root.financial info.funding.sources'].rows[i].value.name = ' '
        }
      }
    },
    fetchCurrency (query) {
      const queryParamName = '?filter[code]&filter[search]=' + query
      const url = this.autoCompleteUrl_currency
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    fetchOrganization (query) {
      const queryParamName = '?filter[search]=' + query
      const url = this.autoCompleteUrl_budgetId
      const cancel = new Promise((resolve) => (this.cancel = resolve))
      const request = this.$http.get(url + queryParamName)
      return Promise.race([cancel, request])
    },
    cancel () {
      // used to 'cancel' previous searches
    },
    setupPage () {
      if (this.$refs.setup) {
        this.$refs.setup.loading = true
      }
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId)
        .then(
          response => {
            this.logConsole(response)
            const form = response.data.payload
            const inputJson = form.inputJson
            const modifiedJson = this.initialActivity(JSON.parse(inputJson))
            const migrated = form.projectMigrated
            this.$refs.setup.formName = form.name
            this.$refs.setup.project = response.data.additionalInformation
            this.$refs.setup.formStatus = form.status
            this.$refs.setup.formCode = form.code
            this.$refs.setup.formatRevisions(form.inputJsonRevisions, 'plan')
            this.$refs.setup.pif = JSON.parse(form.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.initialActivityYears(activityYears)
            this.initialActivity(JSON.parse(form.inputJson))
            this.initializeEditor(modifiedJson, migrated)
            this.$refs.setup.initialVal = form.inputJson === '{}' ? this.$refs.setup.editor.getValue() : modifiedJson

            this.$refs.setup.loading = false
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    changeRevision (selectedRevision) {
      this.$http.get(Vue.$apiConfig.inputFormGet.replace('{projectCode}', this.$route.params.projectCode) + '/forms/' + this.$route.params.phaseFormId + '/revision/' + selectedRevision)
        .then(
          response => {
            // this.logConsole(response)
            const revision = response.data.payload
            this.$refs.setup.pif = JSON.parse(revision.json)
            this.$refs.setup.initialSchema = this.$refs.setup.pif.schema
            this.$refs.setup.initialConfig = this.$refs.setup.pif.config
            this.$refs.setup.initialVal = revision.inputJson ? JSON.parse(revision.inputJson) : null
            this.initializeEditor()
            history.pushState({}, null, ('/projects/' + this.$refs.setup.projectCode + '/phases/' + Number(this.$refs.setup.projectPhaseId) + '/forms/plan/id/' + Number(this.$refs.setup.phaseFormId) + '/revision/' + this.$refs.setup.revision.revision))
          },
          error => {
            this.formatErrorResponse(error)
            this.$refs.setup.loading = false
          }
        )
    },
    initializeEditor (inputJson, migrated) {
      this.$refs.setup.configureEditor()
      this.initialOrganizationAutoComplete()
      this.initialCurrencyAutoComplete(CURRENCY_ID_1, '.currency')
      this.initialCurrencyAutoComplete(CURRENCY_ID_2, '.currency')
      this.initialImplementationDetails(migrated)

      this.$refs.setup.editor.on('ready', () => {
        this.initialMarkdownControls()
        if (this.$refs.setup.initialVal) {
          this.$refs.setup.saveJsonValues(this.$refs.setup.initialVal)
        }
        this.$refs.setup.manageInput()
        this.initialOrganizationAutoComplete()
        this.initialCurrencyAutoComplete(CURRENCY_ID_1, '.currency')
        this.initialCurrencyAutoComplete(CURRENCY_ID_2, '.currency')
        this.roundNumberValues()
      })

      // set initial value for proposer organization when form is from previous phase
      if (inputJson['basic info'] !== undefined) {
        this.$refs.setup.editor.getEditor('root.proposer info.proposer organization.proposer').setValue(inputJson['basic info']['proposer organization'])
        // set initial contacts where form is from previous phase
        this.$refs.setup.editor.getEditor('root.proposer info.authorized organization.authorized contacts').setValue(inputJson['basic info']['authorized people'])
      }

      // var activities = this.$refs.setup.editor.getEditor('implementation.authorized organization.authorized contacts').setValue(years)

      this.$refs.setup.editor.on('change', () => {
        this.handleHiddenFields()
        const values = this.$refs.setup.editor.getValue()
        values[this.$refs.setup.markdownElements[0].name] = this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[0].editor).simplemde_instance.value()
        const val = this.$refs.setup.initialVal
        this.$refs.setup.formChanged = !this.deepEqual(val, values)
        const activityTotal = this.$refs.setup.editor.getEditor('root.totals')
        activityTotal.header.innerHTML = this.formatActivityCalculation(values)
        const fundingTotal = this.$refs.setup.editor.getEditor('root.financial info.totals')
        fundingTotal.header.innerHTML = this.formatFundingCalculation(values)
        const implementation = this.$refs.setup.editor.getEditor('root.implementation')
        const newImpl = this.activityChange(this.$refs.setup.editor.getValue())
        implementation.setValue(newImpl)
      })

      // this.$refs.setup.editor.watch('root.financial info.activityList', () => {
      //   console.log('Promenio se acti')
      //   const implementation = this.$refs.setup.editor.getEditor('root.implementation')
      //   const newImpl = this.activityChange(this.$refs.setup.editor.getValue())
      //   implementation.setValue(newImpl)
      //   console.log(newImpl)
      // })
    },

    initialMarkdownControls () {
      for (var j = 0; j < this.$refs.setup.markdownElements.length; j++) {
        this.$refs.setup.configureMarkdownElement(this.$refs.setup.markdownElements[j])
        if (this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor)) {
          this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[j].editor).simplemde_instance.codemirror.on('change', () => {
            const values = this.$refs.setup.editor.getValue()
            values[this.$refs.setup.markdownElements[0].name] = this.$refs.setup.editor.getEditor(this.$refs.setup.markdownElements[0].editor).simplemde_instance.value()
            const val = this.$refs.setup.initialVal
            this.$refs.setup.formChanged = !this.deepEqual(val, values)
          })
        }
      }
    },
    initialActivityYears (name) {
      const schema = this.$refs.setup.pif.schema
      var years = []
      var currentYear = new Date().getFullYear()
      for (var i = currentYear - 10; i <= currentYear + 10; i++) {
        years.push(i)
      }
      schema.properties.implementation.items.properties.plan.items.properties.year.enum = years
    },
    initialActivity (inputJson) {
      // console.log(inputJson['financial info'].activityList.length)
      const newImplementation = []
      for (var i = 0; i < inputJson['financial info']?.activityList?.length; i++) {
        if (inputJson.implementation[i] === undefined) {
          inputJson.implementation.push(JSON.parse('{"activity": { "name": "' + inputJson['financial info'].activityList[i].name + '", "estimate": "' + inputJson['financial info'].activityList[i].estimate + '" }, "plan": []}'))
          newImplementation.push(inputJson.implementation[i])
        } else {
          inputJson.implementation[i].activity.name = inputJson['financial info'].activityList[i].name
          inputJson.implementation[i].activity.estimate = inputJson['financial info'].activityList[i].estimate
          newImplementation.push(inputJson.implementation[i])
        }
      }
      inputJson.implementation = newImplementation
      return inputJson
    },
    activityChange (inputJson) {
      // console.log(inputJson['financial info'].activityList.length)
      const newImplementation = []
      for (var i = 0; i < inputJson['financial info'].activityList.length; i++) {
        const actName = inputJson['financial info'].activityList[i].name.getValue === undefined ? ' ' : inputJson['financial info'].activityList[i].name.getValue
        const actEstimate = inputJson['financial info'].activityList[i].estimate.getValue === undefined ? ' ' : inputJson['financial info'].activityList[i].estimate.getValue
        if (inputJson.implementation[i] === undefined) {
          inputJson.implementation.push(JSON.parse('{"activity": { "name": "' + actName + '", "estimate": "' + actEstimate + '" }, "plan": []}'))
          newImplementation.push(inputJson.implementation[i])
        } else {
          inputJson.implementation[i].activity.name = inputJson['financial info'].activityList[i].name
          inputJson.implementation[i].activity.estimate = inputJson['financial info'].activityList[i].estimate
          newImplementation.push(inputJson.implementation[i])
        }
      }
      // inputJson.implementation = newImplementation
      return newImplementation
    },
    formatFundingCalculation (values) {
      this.getFundingCalculation(values)
      let data = ''
      for (var j = 0; j < this.fundingCalculations.length; j++) {
        data += '<tr><td>' + this.fundingCalculations[j].currency + '</td><td>' + this.formatAmount(this.fundingCalculations[j].amount) + '</td></tr>'
      }
      if (data !== '') {
        return `Укупно:
            <div class="table_wrapper">
              <table id ="sumActivities">
                <thead style="text-align:right">
                  <tr>
                    <th>Валута</th>
                    <th>Тотал</th>
                  </tr>
                </thead>
                <tbody style="text-align:right">` + data + `</tbody>
              </table>
            </div>`
      } else {
        return ''
      }
    },
    getFundingCalculation (values) {
      this.fundingCalculations = []
      const fundings = values['financial info'].funding.sources
      if (!fundings) return
      var totalAmount = 0
      totalAmount = this.sum(fundings.map(item => item['local amount']))
      totalAmount = totalAmount === '' ? 0 : parseFloat(totalAmount)
      this.fundingCalculations.push({ currency: 'РСД', amount: totalAmount })
    },
    initialOrganizationAutoComplete () {
      this.addNewAutocomplete(ORGANIZATION_ID, this.fetchOrganization)
    },
    formatActivityCalculation (values) {
      const activities = values.implementation
      const activityList = values['financial info']?.activityList
      let mergedYears = []
      var years = activities.map(activity => activity.plan.map(plan => plan.year))
      for (var z = 0; z < years.length; z++) {
        mergedYears = mergedYears.concat(years[z])
      }
      const distinctYears = [...new Set(mergedYears)].sort()
      const estimateAmount = this.getEstimateAmount(values)
      let header = '<tr>'
      header += '<th style="text-align: left; min-width: 350px;" colspan="2"></th>'
      for (var j = 0; j < distinctYears.length; j++) {
        header += '<th style="text-align: center; width: 150px;" colspan="4">' + distinctYears[j] + '</th>'
      }
      header += '</tr>'
      header += '<tr>'
      header += '<th colspan="2">Назив пројектне активности</th>'
      for (j = 0; j < distinctYears.length; j++) {
        header += '<th style="text-align: center; width: 150px;">I</th><th style="text-align: center; width: 150px;">II</th>'
        header += '<th style="text-align: center; width: 150px;">III</th><th style="text-align: center; width: 150px;">IV</th>'
      }
      header += '</tr>'
      if (!activityList) return
      let data = ''
      const yearPercentages = []
      var useAmounts = values['implementation amount value'] === null ? false : values['implementation amount value']
      for (var k = 0; k < activityList.length; k++) {
        data += '<tr>'
        data += '<td style="text-align:left;" colspan="2">' + activityList[k].name + '</td>'
        for (j = 0; j < distinctYears.length; j++) {
          var q1Percent = 0
          var q2Percent = 0
          var q3Percent = 0
          var q4Percent = 0
          const plan = activities[k]?.plan.filter(x => x.year === distinctYears[j]).length > 0 ? activities[k].plan.filter(x => x.year === distinctYears[j])[0] : null
          if (plan) {
            q1Percent = this.getPercentFromEstimateSum(estimateAmount, plan['q1 percent'] ? parseFloat(plan['q1 percent'].toString().replaceAll('.', '').replaceAll(',', '.')) : 0, activityList[k].estimate ? parseFloat(activityList[k].estimate.toString().replaceAll('.', '').replaceAll(',', '.')) : 0, useAmounts)
            q2Percent = this.getPercentFromEstimateSum(estimateAmount, plan['q2 percent'] ? parseFloat(plan['q2 percent'].toString().replaceAll('.', '').replaceAll(',', '.')) : 0, activityList[k].estimate ? parseFloat(activityList[k].estimate.toString().replaceAll('.', '').replaceAll(',', '.')) : 0, useAmounts)
            q3Percent = this.getPercentFromEstimateSum(estimateAmount, plan['q3 percent'] ? parseFloat(plan['q3 percent'].toString().replaceAll('.', '').replaceAll(',', '.')) : 0, activityList[k].estimate ? parseFloat(activityList[k].estimate.toString().replaceAll('.', '').replaceAll(',', '.')) : 0, useAmounts)
            q4Percent = this.getPercentFromEstimateSum(estimateAmount, plan['q4 percent'] ? parseFloat(plan['q4 percent'].toString().replaceAll('.', '').replaceAll(',', '.')) : 0, activityList[k].estimate ? parseFloat(activityList[k].estimate.toString().replaceAll('.', '').replaceAll(',', '.')) : 0, useAmounts)
          }
          if (yearPercentages.filter(x => x.year === distinctYears[j]).length === 0) {
            yearPercentages.push({ year: distinctYears[j], q1: q1Percent, q2: q2Percent, q3: q3Percent, q4: q4Percent })
          } else {
            var index = yearPercentages.findIndex(x => x.year === distinctYears[j])
            yearPercentages[index].q1 += q1Percent
            yearPercentages[index].q2 += q2Percent
            yearPercentages[index].q3 += q3Percent
            yearPercentages[index].q4 += q4Percent
          }

          data += '<td style="text-align:right">' + this.formatAmount(q1Percent, 2) + '</td>'
          data += '<td style="text-align:right">' + this.formatAmount(q2Percent, 2) + '</td>'
          data += '<td style="text-align:right">' + this.formatAmount(q3Percent, 2) + '</td>'
          data += '<td style="text-align:right">' + this.formatAmount(q4Percent, 2) + '</td>'
        }

        data += '</tr>'
      }
      var sumAmounts = ''
      var sumAmountsValue = 0
      if (estimateAmount) {
        for (var s2 = 0; s2 < yearPercentages.length; s2++) {
          sumAmounts += '<td style="text-align:right">' + this.formatAmount((estimateAmount * yearPercentages[s2].q1 / 100), 2) + '</td>'
          sumAmounts += '<td style="text-align:right">' + this.formatAmount((estimateAmount * yearPercentages[s2].q2 / 100), 2) + '</td>'
          sumAmounts += '<td style="text-align:right">' + this.formatAmount((estimateAmount * yearPercentages[s2].q3 / 100), 2) + '</td>'
          sumAmounts += '<td style="text-align:right">' + this.formatAmount((estimateAmount * yearPercentages[s2].q4 / 100), 2) + '</td>'
          sumAmountsValue += (estimateAmount * yearPercentages[s2].q1 / 100) + (estimateAmount * yearPercentages[s2].q2 / 100) + (estimateAmount * yearPercentages[s2].q3 / 100) + (estimateAmount * yearPercentages[s2].q4 / 100)
        }
      }

      var sumPercentage = ''
      var sumPercentageValue = 0
      for (j = 0; j < yearPercentages.length; j++) {
        sumPercentage += '<th style="text-align:right">' + this.formatAmount(yearPercentages[j].q1, 2) + '</th>'
        sumPercentage += '<th style="text-align:right">' + this.formatAmount(yearPercentages[j].q2, 2) + '</th>'
        sumPercentage += '<th style="text-align:right">' + this.formatAmount(yearPercentages[j].q3, 2) + '</th>'
        sumPercentage += '<th style="text-align:right">' + this.formatAmount(yearPercentages[j].q4, 2) + '</th>'
        sumPercentageValue += yearPercentages[j].q1 + yearPercentages[j].q2 + yearPercentages[j].q3 + yearPercentages[j].q4
      }
      return `Укупно:
            <div class="table_wrapper_activities">
              <table id ="sumActivities">
                <thead>
                  ` + header + `
                </thead>
                <tbody>` + data + `</tbody>
                <tr><th>Укупно %</th><th style="text-align:right">` + this.formatAmount(sumPercentageValue, 2) + '</th>' + sumPercentage + `</tr>
                <tbody>
                  <tr><td>РСД</td><td style="text-align:right">` + this.formatAmount(sumAmountsValue, 2) + '</td>' + sumAmounts + `</tr>
                </tbody>
              </table>
            </div>`
    },
    getPercentFromEstimateSum (estimateAmount, quartalActivityPercent, activityAmount, useAmounts) {
      const quartalActivitySum = useAmounts ? quartalActivityPercent : activityAmount / 100 * quartalActivityPercent
      return estimateAmount > 0 ? quartalActivitySum / estimateAmount * 100 : 0
    },
    getEstimateAmount (values) {
      return values['financial info']['price local'] ? parseFloat(values['financial info']['price local'].toString().replaceAll('.', '').replaceAll(',', '.')) : 0
    },
    initialCurrencyAutoComplete (name, sufix) {
      if (this.$refs.setup.editor.editors[name]) {
        for (let i = 0; i <= this.$refs.setup.editor.editors[name].rows.length - 1; i++) {
          this.addNewAutocomplete(name + '.' + i + sufix, this.fetchCurrency)
        }

        this.$refs.setup.editor.editors[name].add_row_button.onclick = (result) => {
          return this.addNewCurrencyAutocomplete(name, sufix)
        }
      }
    },
    initialImplementationDetails (migrated) {
      if (!migrated) {
        console.log('Usao u if')
        this.$refs.setup.editor.getEditor('root.basic info.implementation details').options.hidden = true
      }
    },
    addNewCurrencyAutocomplete (controlName, sufix) {
      const index = this.$refs.setup.editor.editors[controlName].rows.length - 1
      const name = controlName + '.' + index + sufix
      this.addNewAutocomplete(name, this.fetchCurrency)
    },
    addNewAutocomplete (name, fetchFunction) {
      this.$refs.setup.editor.editors[name].options.autocomplete.search = function (input) {
        return new Promise(function (resolve) {
          if (input.length < 2) {
            return resolve([])
          }
          fetchFunction(input).then(function (response) {
            return response.json()
          }).then(function (data) {
            resolve(data.payload)
          })
        })
      }

      this.formatAutocompleteResult(name)
    },
    formatAutocompleteResult (name) {
      this.$refs.setup.editor.editors[name].options.autocomplete.getResultValue = (result) => {
        return name.includes('currency') ? result.exchangeCode + ' ' + this.formatAmount(result.exchangeRate) : result.id + ' - ' + result.name
      }
      this.$refs.setup.editor.editors[name].options.autocomplete.renderResult = (result, props) => {
        const title = name.includes('currency') ? result.exchangeCode : result.id
        const subtitle = name.includes('currency') ? this.formatAmount(result.exchangeRate) : result.name

        return ['<li ' + props + '>',
          '<div class="wiki-title">' + title + '</div>',
          '<div class="wiki-snippet"><small>' + subtitle + '<small></div>',
          '</li>'].join('')
      }
    },
    roundNumberValues () {
      const editors = this.$refs.setup.editor.editors
      for (const key in editors) {
        if (editors[key].format === 'integer') {
          editors[key].setValue(this.formatAmount(this.formatNumber(editors[key].getValue()), 0))
        }
      }
    }
  },
  created () {
    this.setupPage()
    EventBus.$on('setupPage', () => {
      this.handleHiddenFields()
      if (this.$refs && this.$refs.setup) {
        this.$refs.setup.revision = {
          revision: null
        }
      }
      this.setupPage()
    })
    EventBus.$on('changeRevision', (revision) => {
      this.changeRevision(revision)
    })
  },
  beforeDestroy () {
    EventBus.$off('setupPage')
    EventBus.$off('changeRevision')
  }
}
</script>

<style>
#sumActivities {
  border-collapse: collapse;
  /* width: 100%; */
}

#sumActivities td, #sumActivities th {
  border: 1px solid #ddd;
  padding: 8px;
}

#sumActivities tr:nth-child(even){background-color: #f2f2f2;}

#sumActivities tr:hover {background-color: #ddd;}

#sumActivities th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: var(--v-primary-base);
  color: white;
}

.table_wrapper_activities {
    display: block;
    overflow-x: auto;
}
</style>
